import {
  getNotificationList,
  getUnreadCount,
  markNotificationRead,
  markAllNotificationsRead,
} from '@/services/notificationService'

const state = {
  list: [],
  unreadCount: 0,
  totalCount: 0,
  loading: false,
}

const mutations = {
  SET_LIST(state, list) {
    state.list = list
  },
  SET_UNREAD_COUNT(state, count) {
    state.unreadCount = count
  },
  SET_TOTAL_COUNT(state, count) {
    state.totalCount = count
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  MARK_ITEM_READ(state, id) {
    const item = state.list.find((n) => n.id === id)
    if (item && !item.isRead) {
      item.isRead = true
      if (state.unreadCount > 0) state.unreadCount--
    }
  },
  MARK_ALL_READ(state) {
    state.list.forEach((item) => {
      item.isRead = true
    })
    state.unreadCount = 0
  },
  CLEAR(state) {
    state.list = []
    state.unreadCount = 0
    state.totalCount = 0
    state.loading = false
  },
}

const actions = {
  async fetchUnreadCount({ commit }) {
    const { data, error } = await getUnreadCount({}, { silent: true })
    if (error) return
    commit('SET_UNREAD_COUNT', data.unreadCount || 0)
  },

  async fetchList({ commit }, params = {}) {
    commit('SET_LOADING', true)
    const { data, error } = await getNotificationList({
      offset: params.offset || 0,
      limit: params.limit || 10,
    })
    commit('SET_LOADING', false)
    if (error) return
    commit('SET_LIST', data.list || [])
    commit('SET_TOTAL_COUNT', data.totalCount || 0)
  },

  async markRead({ commit }, id) {
    commit('MARK_ITEM_READ', id)
    await markNotificationRead({ id })
  },

  async markAllRead({ commit }) {
    commit('MARK_ALL_READ')
    await markAllNotificationsRead({})
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
